import styled from 'styled-components';
import colors from '../../../assets/styles/colors';

export const DisbursementModalityContentForm = styled.div`
  margin-top: 30px;
`;

export const DisbursementModalitySubtitleForm = styled.h6`
  color: ${colors.textPrimary};
  font-size: 16px;
  line-height: 23px;
  margin-top: 30px;
  margin-bottom: -30px;
`;

export const DisbursementModalityErrorMessage = styled.span`
  font-size: 12px;
  color: ${colors.bgDanger};
  line-height: 14px;
  margin-top: -20px;
`;
